// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2Samc","rowsWrapper":"style_rowsWrapper__2uzP5","rowWrapper":"style_rowWrapper__2Sz5e"};